module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-icon01.f3079924.svg";